import React, { forwardRef } from 'react';
import {
  Box,
  Menu,
  Image,
  LinkBox,
  MenuList,
  MenuButton,
  IconButton,
  LinkOverlay,
  useStyleConfig,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { brandURL } from '../../config';
import logoSRC from '../../assets/branding/logo.png';
import shortLogo from '../../assets/branding/short-logo.svg';

const HamburgerButton = forwardRef((props, ref) => {
  const styles = useStyleConfig('Header');

  return (
    <IconButton
      __css={styles.menu}
      aria-label="menu"
      variant="ghost"
      colorScheme="gray"
      icon={<HamburgerIcon fontSize={{ base: '1.5rem', md: '2rem' }} />}
      {...props}
      ref={ref}
    />
  );
});

function Header(props) {
  const {
    variant,
    children,
    displayBrand = 'flex',
    menuListComponents,
    ...contentProps
  } = props;
  const styles = useStyleConfig('Header', { variant });

  return (
    <Box as="header" __css={styles.header} {...contentProps}>
      <LinkBox __css={styles.brand} display={displayBrand} alignItems="center" justifyContent="center" px="1rem">
        <LinkOverlay href={brandURL} target="_blank" display={{ base: 'none', sm: 'block' }}>
          <Image src={logoSRC} height="1.5rem" width="10rem" />
        </LinkOverlay>
        <LinkOverlay href={brandURL} target="_blank" display={{ base: 'block', sm: 'none' }}>
          <Image src={shortLogo} height="1.5rem" width="2rem" />
        </LinkOverlay>
      </LinkBox>
      <Box __css={styles.navbar}>
        {children}
      </Box>
      <Menu>
        <MenuButton as={HamburgerButton} />
        <MenuList>
          {menuListComponents}
        </MenuList>
      </Menu>
    </Box>
  );
}

export default Header;
